'use client';
import * as React from 'react';
export const AccordionContext = React.createContext({
    icon: 'plus',
    variant: 'dark',
    isTransparent: false,
    withAnimation: false,
});
export const useAccordionContext = () => React.useContext(AccordionContext);
export const AccordionSectionContext = React.createContext({
    disabled: false,
    isActive: false,
    index: 0,
    setIsActive: () => { },
});
export const useAccordionSectionContext = () => React.useContext(AccordionSectionContext);
export const AccordionSingleOpenContext = React.createContext({
    currentAccordionSection: -1,
    setCurrentAccordionSection: (currentAccordionSection) => currentAccordionSection,
});
export const useAccordionSingleOpenContext = () => React.useContext(AccordionSingleOpenContext);
//# sourceMappingURL=Accordion.js.map